
  import Vue from 'vue'
  import {getInputErrorMessage, hasErrors, hasRequiredNotFilled} from "@/utils/form";
  import pageMixin from "@/mixins/page";
  import {BreadcrumbItems, BreadcrumbItemType} from "@/utils/breadcrumb";
  import { MetaInfo } from 'vue-meta';
  import {ROUTES} from "@/router/routes";

  const REQUIRED_ITEMS = ['name', 'surname', 'email', 'message'];
  export default Vue.extend({
    name: "AboutUs",
    mixins: [pageMixin],
    components: {
      PwaStats: () => import("@/components/PwaStats.vue"),
      PwaFooter: () => import('@/components/layout/PwaFooter.vue'),
    },
    data() {
      return {
        form: {
          name: '',
          surname: '',
          phone: '',
          email: '',
          message: '',
        } as any,
        errors: {} as any,
        stats: [
          {
            icon: 'about-us/energy-drink-stats.svg',
            description: '325',
            num: '540'
          },
          {
            icon: 'about-us/stream-stats.svg',
            description: '326',
            num: '130K'
          },
          {
            icon: 'about-us/pizza-stats.svg',
            description: '327',
            num: '1M'
          }
        ],
        values: [
          {
            img: 'about-us/column.svg',
            title: '318',
            info: '319',
          },
          {
            img: 'about-us/column.svg',
            title: '320',
            info: '321',
          },
          {
            img: 'about-us/column.svg',
            title: '322',
            info: '323',
          }
        ],
        breadcrumb: [{labelId: BreadcrumbItems.aboutUs.labelId}] as BreadcrumbItemType[],
      }
    },
    computed: {
      hasErrors(): boolean {
        return hasErrors(this.errors);
      },
      hasRequiredNotFilled(): boolean {
        return hasRequiredNotFilled(REQUIRED_ITEMS, this.form);
      },
      submitDisabled(): boolean {
        return this.hasErrors || this.hasRequiredNotFilled;
      },
      metaData(): MetaInfo {
        return {
          title: this.$t('422'),
          meta: [
            {name: 'description', content: this.$t('423')},
            {name: 'robots', content: 'index'}
          ],
          link: this.getMetaDataPathLinks(ROUTES.aboutUs.path),
        };
      },
    },
    methods: {
      async submit() {
        try {
          this.showLoader(true);
          let params = {
            name: this.form.name,
            surname: this.form.surname,
            email: this.form.email,
            message: this.form.message
          } as any;

          if (this.form.phone) {
            params.phone = this.form.phone
          }

          await this.$http.auth.postContact(params);
          this.form = {
            name: '',
            surname: '',
            phone: '',
            email: '',
            message: '',
          };
          this.errors = {};
          this.showToastSuccess(this.$t('359'), this.$t('358'));
          this.scrollToTop();
        } catch (error) {
          this.showToastError(this.$t('139'), this.$t('140'));
        } finally {
          this.showLoader(false);
        }
      },
      onInputBlur(event: Event) {
        const input = event.target as HTMLInputElement;
        const field = input.name;
        const value: string = this.form[field];
        const inputLabel = field === 'message' ? this.$t('360').toLowerCase() : null;
        const errorMessage = getInputErrorMessage(input, value, inputLabel);

        this.$set(this.errors, field, errorMessage);
      },
    },
  });
